module.exports = __webpack_public_path__ + "static/img/Banniere.f3b5059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Banniere.jpg
// module id = lHqo
// module chunks = 1